import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { SystemHealthResponse } from "@/api/types";

const REFETCH_MS = 30_000;

export function useSystemHealth() {
  return useQuery({
    queryKey: ["system-health"],
    queryFn: ({ signal }) =>
      api<SystemHealthResponse>("/api/v1/health/system", { signal }),
    refetchInterval: REFETCH_MS,
    placeholderData: (prev) => prev,
  });
}
